module.exports = __webpack_public_path__ + "static/media/kmchomes.e27c6b10.png";